import { render } from "./Order.vue?vue&type=template&id=5447c474"
import script from "./Order.vue?vue&type=script&lang=ts"
export * from "./Order.vue?vue&type=script&lang=ts"
script.render = render

export default script